const resetPasswordConstraints = (customValidationMessages) => ({
  loginEmail: {
    ...customValidationMessages.loginEmail,
    presence: {
      allowEmpty: false,
    },
    email: true,
    length: {
      maximum: 254,
    },
  },
})
export default resetPasswordConstraints
